import { Localization } from '@material-ui/core/locale';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const pageLang = document.querySelector('html')?.getAttribute('lang') || 'en';

let lang: Localization;
switch (pageLang) {
  case 'cs': {
    lang = require('@material-ui/core/locale').csCZ;
    break;
  }

  default: {
    lang = require('@material-ui/core/locale').enUS;
    break;
  }
}

const theme = createTheme(
  {
    props: {
      MuiTextField: { variant: 'outlined', InputLabelProps: { shrink: true } },
    },
    typography: {},
    palette: {
      success : {
        main : '#bac778',
        contrastText: '#bac000',
      },
      primary: {
        // main: '#0a79bf',
        main: '#0e1f3e',
        contrastText: '#FFF',
      },
      secondary: {
        main: '#FFF',
        contrastText: '#000',
      },
      text: {
        primary: '#000000',
        secondary: '#7e7e7e',
      },
    },
  },
  lang
);

interface ProviderProps {
  children: React.ReactNode[] | React.ReactNode;
}

const EdocatThemeProvider = (props: ProviderProps) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default EdocatThemeProvider;
